import * as React from "react";
import { ForwardedRef, forwardRef } from "react";
import styled from "@mui/material/styles/styled";
import { GenericButton } from "../uiControllers/genericButton";
import { usePatient } from "../../state/patientContext";
import { DocQuestion } from "./DocQuestion";

//region [[ Styles ]]

const StopCriteriaView = styled("div")({
  margin: "0",
});

const InfoButton = styled("div")({
  display: "flex",
  "& .only-button": {
    minWidth: "120",
  },
  marginTop: "10px",
  marginBottom: "10px",
  justifyContent: "flex-end",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface InfoElementProps {
  infoText: string;
  onContinue: () => void;
  continueLabel: string;
  onStop?: () => void;
  stopLabel?: string;
  noConfirm?: boolean;
  miniView?: boolean;
  answered?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const InfoElement = forwardRef(
  ({ ...props }: InfoElementProps, ref: ForwardedRef<any>) => {
    const { loading } = usePatient();

    const onStart = () => {
      props.onContinue();
    };

    return (
      <StopCriteriaView className={"stop-criteria-view"}>
        <DocQuestion text={props.infoText} miniView={props.miniView} />
        <InfoButton ref={props.answered || !props.noConfirm ? ref : null}>
          {!props.noConfirm && (
            <GenericButton
              className={props.onStop ? "primary-button" : "only-button"}
              onClick={onStart}
              label={props.continueLabel}
              disabled={props.answered || loading}
            />
          )}
          {props.onStop && (
            <GenericButton
              className={"secondary-button"}
              onClick={props.onStop}
              label={props.stopLabel}
              disabled={loading}
            />
          )}
        </InfoButton>
      </StopCriteriaView>
    );
  },
);
